import React, { useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';

const ChannelsAutoCompleteEditor = ({ field, rowData, rowIndex, dataKey, editorCallback, selectedChannels, setSelectedChannels, channels, validationErrors }) => {
    const newDataKey = rowData[dataKey]
    const selectedChannel = selectedChannels.current[newDataKey] || ''
    const [filteredChannels, setFilteredChannels] = useState([]);
    const search = (event) => {
        setTimeout(() => {
            let filteredChannels1
            if (!event.query.trim()
                .length) {
                filteredChannels1 = [...channels]
            }
            else {
                filteredChannels1 = channels.filter((channel) => {
                    return channel.name.toLowerCase()
                        .startsWith(event.query.toLowerCase())
                })
            }
            setFilteredChannels([...filteredChannels1]) // Force update
        }, 250)
    }
    return (
        <AutoComplete
            value={selectedChannel}
            suggestions={filteredChannels}
            completeMethod={search}
            onChange={(e) => {
                const newSelectedChannels = { ...selectedChannels.current }
                newSelectedChannels[newDataKey] = e.value
                setSelectedChannels(newSelectedChannels)
                editorCallback(e.value)
            }}
            onFocus={(e) => e.target.select()}
            className={validationErrors[rowIndex] && validationErrors[rowIndex][field] ? 'p-invalid' : ''}
            field="name" />
    )
}

export default ChannelsAutoCompleteEditor